import { Button, ValidationError, Overlay } from '../../components';
import { EditorState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import React, { useEffect } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentManagementService } from '../../services';
import { useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  FormControl, MenuItem, Select,
} from '@material-ui/core';
import './addfaq.global.scss';
import '../LayoutWrapperMain/LayoutWrapperMain.global.scss';

enum ButtonTypes {
  'button',
  'submit',
  'reset',
  undefined
}

interface Props {
  intl: any;
}

const AddFAQsComponent = (props: Props) => {
  const { intl } = props;
  const [categories, setCategories] = React.useState([]);
  const [overlay, setOverlay] = React.useState(true);
  useEffect(() => {
    ContentManagementService.getFAQCategory().then((res: any) => {
      setCategories(res.data.data.data);
      setOverlay(false);
    });
  }, []);
  const [id, setId] = React.useState<any>();
  const [answerState, setAnswerState] = React.useState<any>(EditorState.createEmpty());
  const [questionState, setQuestionState] = React.useState<any>(EditorState.createEmpty());
  const [error, setError] = React.useState('');
  const navigate = useNavigate();

  return (
    <>
      {overlay && <Overlay />}
      <h2>
        {intl.formatMessage({ id: 'AddFaq.label.title' })}
      </h2>
      <div>
        <h2>Category</h2>
        <FormControl fullWidth>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            className="dropdown_wrap"
            value={id}
            label="Category"
            onChange={(val: any) => {
              const name: any = categories.filter((ele: any) => ele._id === val.target.value);
              setId({ id: name[0]._id, name: name[0].name });
            }}
          >
            {categories.map((ele: any) => <MenuItem value={ele._id}>{ele.name}</MenuItem>)}
          </Select>
        </FormControl>
      </div>
      <h2>
        {intl.formatMessage({ id: 'AddFaq.label.question' })}
      </h2>
      <Editor
        editorState={questionState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={(e) => setQuestionState(e)}
        toolbar={{
          options: ['inline', 'textAlign', 'link'],
          inline: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['bold', 'italic', 'underline'],
          },
          textAlign: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['left', 'center', 'right', 'justify'],
          },
          link: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            popupClassName: undefined,
            dropdownClassName: undefined,
            showOpenOptionOnHover: true,
            defaultTargetOption: '_self',
            options: ['link'],
            linkCallback: undefined,
          },
        }}
      />
      <h2>
        {intl.formatMessage({ id: 'AddFaq.label.answer' })}
      </h2>
      <Editor
        editorState={answerState}
        toolbarClassName="toolbarClassName"
        wrapperClassName="wrapperClassName"
        editorClassName="editorClassName"
        onEditorStateChange={(e) => setAnswerState(e)}
        toolbar={{
          options: ['inline', 'textAlign', 'link'],
          inline: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['bold', 'italic', 'underline'],
          },
          textAlign: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            dropdownClassName: undefined,
            options: ['left', 'center', 'right', 'justify'],
          },
          link: {
            inDropdown: false,
            className: undefined,
            component: undefined,
            popupClassName: undefined,
            dropdownClassName: undefined,
            showOpenOptionOnHover: true,
            defaultTargetOption: '_self',
            options: ['link'],
            linkCallback: undefined,
          },
        }}
      />
      {error.length > 0 && <ValidationError error={error} />}
      <div className="buttonWrapper">
        <Button
          buttonType={ButtonTypes.button}
          onClick={() => {
            if (answerState.getCurrentContent().getPlainText().length === 0
              || questionState.getCurrentContent().getPlainText().length === 0) {
              setError('Please fill all fields.');
            } else {
              ContentManagementService.addToDraftFAQ(
                {
                  categoryId: id.id,
                  categoryName: id.name,
                  question: stateToHTML(questionState.getCurrentContent()),
                  answer: stateToHTML(answerState.getCurrentContent()),
                  status: 'draft',
                },
              ).then(() => {
                setError('');
                navigate('/contentmanagement?active=FAQ');
              });
            }
          }}
        >
          {intl.formatMessage({ id: 'AddFaq.button.draft' })}
        </Button>
        <Button
          buttonType={ButtonTypes.button}
          onClick={() => {
            if (answerState.getCurrentContent().getPlainText().length === 0
              || questionState.getCurrentContent().getPlainText().length === 0) {
              setError('Please fill all fields.');
            } else {
              ContentManagementService.addToDraftFAQ(
                {
                  categoryId: id.id,
                  categoryName: id.name,
                  question: stateToHTML(questionState.getCurrentContent()),
                  answer: stateToHTML(answerState.getCurrentContent()),
                  status: 'unblocked',
                },
              ).then(() => {
                setError('');
                navigate('/contentmanagement?active=FAQ');
              });
            }
          }}
        >
          {intl.formatMessage({ id: 'AddFaq.button.publish' })}
        </Button>
      </div>
    </>
  );
};

const mapStateToProps = () => ({
});
const mapDispatchToProps = () => ({
});

const AddFAQs = compose<React.ElementType>(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
)(AddFAQsComponent);

export default AddFAQs;
